import React from 'react'

import { mq } from 'marketing-site/src/library/utils'
import { Text } from '../../elements/Text'
import { IJob } from './index'
import { Job } from './job'

interface IJobCategoryProps {
  title: string
  jobs: IJob[]
  cta?: React.ReactNode
}

export const JobCategory = ({ title, jobs, cta }: IJobCategoryProps): React.ReactElement => {
  return (
    <div className="greenhouse-listings__category">
      <p className="greenhouse-listings__category-title greenhouse-listings__category-custom-title">
        <Text brand="default" size="heading-4">
          {title}{' '}
        </Text>
        {cta}
      </p>
      <ul className="greenhouse-listings__category__job-listings">
        {jobs.map((job: IJob) => (
          <Job job={job} key={job.id} />
        ))}
      </ul>

      <style jsx>
        {`
          .greenhouse-listings {
            &__category {
              width: 100%;

              & + & {
                margin-top: 2.5rem;
              }
            }

            &__category-title {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding-bottom: 1.5rem;
            }

            &__category-custom-title {
              :global(& > span:first-child) {
                font-size: 1.625rem;
                margin-right: 0.75rem;
              }
            }
          }

          @media (${mq.laptop}) {
            .greenhouse-listings {
              &__category {
                width: calc(50% - 3.4375rem);

                & + & {
                  margin-top: 0;
                }

                & + &:not(:nth-child(2)) {
                  margin-top: 3rem;
                }
              }

              &__category-title {
                padding-bottom: 2rem;
              }
            }
          }
        `}
      </style>
    </div>
  )
}
